import React from 'react';

const ScanCode = ({ parkingPass, className }) => {
  const scanCode = parkingPass.validation.scanCode.get('code');

  let scanCodeText;
  if (scanCode.length <= 20) {
    scanCodeText = (
      <p className="scan-code-text text-color-dark-slate text-weight-medium text-center">
        {scanCode}
      </p>
    );
  }
  return (
    <div className={`scan-code force-show-print ${className}`}>
      <img src={parkingPass.scanCodeURL} className="scan-code-image" alt="" />
      {scanCodeText}
    </div>
  );
};

export default ScanCode;
